import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsStop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M.16.16h15.68v15.68H.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsStop
